import { createFileRoute } from '@tanstack/react-router';

import { SectionPlaceholder } from '@/shared/ui/SectionPlaceholder';

export const Route = createFileRoute('/_app/analytics')({
  component: () => <SectionPlaceholder title="Аналитика / CRM" icon="analytics" />,
});
